import { State } from '../reducers/rootReducer'
import { InitParametersState } from '../reducers/initParametersReducer'

const initParametersSelector = (state: State): InitParametersState => state.initParameters

export default initParametersSelector
